export default __webpack_public_path__ + "c83f650f279126d8b0415b1f792907f0.svg";